<section class="logs__block section-inset-y">
  <div class="container">
    <div class="logs__block__header">
      <h2>
        <small class="text-primary">{{ 'blogs-en-vlogs-subtitel' | fromDictionary }}</small>
        {{ 'blogs-en-vlogs-titel' | fromDictionary }}
      </h2>
      <a class="more__button button button-link button-link--muted mb-0" [routerLink]="['/blogs']">
        <span>Alle blogs & vlogs</span>
      </a>
    </div>
    <ul class="row">
      @for (blog of blogs(); track blog) {
        <li class="col-sm-6 mb-2 mb-lg-0 col-lg-3 d-flex">
          <app-card
            [title]="blog.title"
            [text]="blog.videoUrl ? null : (blog.text | stripHtml | truncate: 150)"
            [date]="blog.publishDate"
            [author]="blog.author"
            [imageUrl]="blog.imageUrl"
            [imageAnchor]="blog?.imageAnchor"
            [videoUrl]="blog.videoUrl"
            [link]="blog.routerLink"
          ></app-card>
        </li>
      }
    </ul>
  </div>
</section>
